import { useTranslation } from "react-i18next";
import { XMarkIcon } from "@heroicons/react/24/outline";

const SecureSimpliGetStarted = ({ open, setOpen, privacyPolicy, termsOfUse }) => {
  const { t } = useTranslation();
  return (
    <>
      {open && (
        <div className="p-[2px] bg-rs-border-gradient rounded-2xl mx-auto w-full max-w-2xl lg:max-w-[902px]">
          <div className="relative transform overflow-hidden rounded-2xl bg-white p-8 text-center transition-all">
            {/* CLOSE BUTTON */}
            <button
              onClick={() => setOpen(false)}
              className="absolute right-4 top-4 text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-0"
            >
              <XMarkIcon className="h-5 w-5" />
            </button>

            {/* TITLE */}
            <h3 as="h2" className="text-2xl lg:text-[36px] font-semibold text-[#16283D]">
              {t("secure_simpli_get_started_modal.headline")}
            </h3>
            <p className="mt-2 text-sm md:text-lg text-[#16283D]">
              {t("secure_simpli_get_started_modal.sub_headline")}
            </p>

            {/* 3 STEPS */}
            <div className="mt-8 flex flex-col items-center md:items-baseline justify-center gap-8 sm:flex-row sm:gap-10">
              {/* Step 1 */}
              <div className="flex flex-col items-center text-center w-[184px]">
                <div className="flex h-[70px] w-[70px] md:h-[100px] md:w-[100px] items-center justify-center rounded-xl bg-indigo-50">
                  <img
                    src={process.env.PUBLIC_URL + "/static/images/darkblue-vault.svg"}
                    alt="Simpli"
                    className="w-[50px] md:w-[60px]"
                  />
                </div>
                <h3 className="mt-4 px-2 md:px-0 text-sm lg:text-base font-bold text-[#16283D]">
                  {t("secure_simpli_get_started_modal.content_line_headline1")}
                </h3>
                <p className="mt-1 text-xs lg:text-base text-[#16283D] px-2">
                  {t("secure_simpli_get_started_modal.content_line1")}
                </p>
              </div>
              <div className="relative hidden sm:block">
                <div className="absolute top-[-26px] left-[-30px] w-[60px] border-t-2 border-dashed border-blue-300"></div>
              </div>
              {/* Step 2 */}
              <div className="flex flex-col items-center text-center w-[184px] relative">
                <div className="flex h-[70px] w-[70px] md:h-[128px] md:w-[128px] items-center justify-center rounded-xl bg-indigo-50">
                  <img
                    src={process.env.PUBLIC_URL + "/static/images/uploade-file-icon.svg"}
                    alt="Simpli"
                    className="w-[50px] md:w-[76px]"
                  />
                </div>
                <h3 className="mt-4 px-2 md:px-0 text-sm lg:text-base font-bold text-[#16283D]">
                  {t("secure_simpli_get_started_modal.content_line_headline2")}
                </h3>
                <p className="mt-1 text-xs lg:text-base text-[#16283D] px-2">
                  {t("secure_simpli_get_started_modal.content_line2")}
                </p>
              </div>
              <div className="relative hidden sm:block">
                <div className="absolute top-[-26px] left-[-30px] w-[60px] border-t-2 border-dashed border-blue-300"></div>
              </div>
              {/* Step 3 */}
              <div className="flex flex-col items-center text-center w-[184px]">
                <div className="flex h-[70px] w-[70px] md:h-[100px] md:w-[100px] items-center justify-center rounded-xl bg-indigo-50">
                  <img
                    src={process.env.PUBLIC_URL + "/static/images/desktop-mobile-icon.svg"}
                    alt="Simpli"
                    className="w-[50px] md:w-[60px]"
                  />
                </div>
                <h3 className="mt-4 px-2 md:px-0 text-sm lg:text-base font-bold text-[#16283D]">
                  {t("secure_simpli_get_started_modal.content_line_headline3")}
                </h3>
                <p className="mt-1 text-xs lg:text-base text-[#16283D] px-2">
                  {t("secure_simpli_get_started_modal.content_line3")}
                </p>
              </div>
            </div>

            {/* CTA BUTTON */}
            <div className="mt-6">
              <button
                onClick={() => setOpen(false)}
                className="inline-flex items-center justify-center rounded-full max-w-[328px] focus:outline-none focus:ring-0
                  text-white px-[20px] md:px-[40px] py-[16px] leading-[120%] font-rethink tracking-[2%] text-md md:text-xl font-bold bg-ps-reskin-radial hover:bg-hover-ps-reskin-radial uppercase transition-colors duration-1000 ease-in-out"
              >
                {t("secure_simpli_get_started_modal.get_started_now")} →
              </button>
            </div>
            <div className="px-[10px]">
              <p
                className="mt-4 text-[14px] text-[#264A73] px-4 md:px-[7rem] lg:px-[12rem]"
                dangerouslySetInnerHTML={{
                  __html: t("secure_simpli_get_started_modal.footer_line")
                    .replace(
                      "##TermsConditions##",
                      `<a href="${termsOfUse}" target="_blank" rel="noopener noreferrer" class="text-[#0E76FF] hover:underline">Terms of Use</a>`
                    )
                    .replace(
                      "##PrivacyPolicy##",
                      `<a href="${privacyPolicy}" target="_blank" rel="noopener noreferrer" class="text-[#0E76FF] hover:underline">Privacy Policy</a>`
                    ),
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SecureSimpliGetStarted;
